import { CodePromoResponse } from './../models/api_models/codePromo';
import {  Injectable} from '@angular/core';
import {  AutorizationService} from './autorization.service';
import {  Observable} from 'rxjs';
import { Station} from '../models/api_models/station';
import { HttpHeaders, HttpClient} from '@angular/common/http';
import {  Token} from '../models/api_models/token';
import { BookResult, ExtendCalc, ExtendConfirm} from '../models/api_models/book';
import { BasicResponse} from '../models/api_models/basicResponse';
import {  BilanEco, UserApi} from '../models/api_models/user';
import { UserApiService } from '../user-api.service';
import {  CookieService} from 'ngx-cookie-service';
import { Subject }    from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BookService {
  publicUrl = "https://api1.clem.mobi/";

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    })
  };


// shared service 
 public _subject = new Subject<any>();
     public event = this._subject.asObservable();

     public publish(data: any) {
       this._subject.next(data);
     }




  public cancelBook(bookId: number) {
    return new Observable < any > ((observer) => {
      this.autorizationService.login(null).subscribe(reponse => {
        let token = < Token > reponse;
        // conslog("login");
        if (token == null) {
          observer.next(null)
          observer.complete()
        }
        var header = {
          headers: new HttpHeaders()
            .set('Authorization', 'Bearer ' + token.access_token)
        }

        //            this.GetALLStations(0,token, observer);

        this.http.delete(this.publicUrl + "api/v2/books/" + bookId, header).subscribe(
          response => {
            // conslog(response);
            observer.next(response);
            observer.complete();
          }
        )
      });
    });
  }

  public estimeExtendBook(bookId: number, duration: number) {
    return new Observable < ExtendCalc > ((observer) => {
      this.autorizationService.login(null).subscribe(reponse => {
        let token = < Token > reponse;
        // conslog("login");
        if (token == null) {
          observer.next(null)
          observer.complete()
        }
        var header = {
          headers: new HttpHeaders()
            .set('Authorization', 'Bearer ' + token.access_token)
        }

        //            this.GetALLStations(0,token, observer);

        this.http.get(this.publicUrl + "api/v2/books/" + bookId + "/extension_price?duration=" + duration, header).subscribe(
          response => {
            observer.next( < ExtendCalc > ( < BasicResponse > response).data);
            observer.complete();
          }
        )
      });
    });
  }

  public confirmExtendBook(bookId: number, duration: number) {
    // conslog(duration);

    return new Observable < ExtendConfirm > ((observer) => {
      this.autorizationService.login(null).subscribe(reponse => {
        let token = < Token > reponse;
        // conslog("login");
        // conslog(reponse);

        if (token == null) {
          observer.next(null)
          observer.complete()
        }
        let header = {
          headers: new HttpHeaders()
            .set('Authorization', 'Bearer ' + token.access_token)
            .set('Content-Type', 'application/x-www-form-urlencoded')
        }

        header.headers.append('Access-Control-Allow-Origin', '*');
        header.headers.append('Access-Control-Allow-Methods', 'GET, POST, OPTIONS, PUT, PATCH, DELETE');
        header.headers.append('Access-Control-Allow-Headers', 'X-Requested-With,content-type');
        header.headers.append('Access-Control-Allow-Credentials', 'true');
        //            this.GetALLStations(0,token, observer);

        this.http.put("https://api1.clem.mobi/api/v2/books/" + bookId + "/extension", 'duration=' + duration, header).subscribe(
          response => {
            observer.next( < ExtendConfirm > ( < BasicResponse > response).data);
            observer.complete();
          }
        )
      });
    });
  }

  public getBooks() {
    return new Observable < BookResult[] > ((observer) => {


      this.autorizationService.login(null).subscribe(reponse => {
        let token = < Token > reponse;
        // conslog("login");
        if (token == null) {
          observer.next(null)
          observer.complete()
        }
        let header = {
          headers: new HttpHeaders()
            .set('Authorization', 'Bearer ' + token.access_token)
        }

        //            this.GetALLStations(0,token, observer);

        this.http.get(this.publicUrl + "api/v2/books", header).subscribe(
          response => {
            observer.next( < BookResult[] > ( < BasicResponse > response).data);
            observer.complete();
          },
          error => {
            observer.next(null);
            observer.complete();

          }
        )
      });
    });
  }

  public getBookDetail(bookId: number, lang) {
    return new Observable < BookResult > ((observer) => {
      this.autorizationService.login(null).subscribe(reponse => {
        let token = < Token > reponse;
        // conslog("login");
        if (token == null) {
          observer.next(null)
          observer.complete()
        }

        var header = {
          headers: new HttpHeaders()
            .set('Authorization', 'Bearer ' + token.access_token)
            .set('Content-Type', 'application/x-www-form-urlencoded')
        }

        //            this.GetALLStations(0,token, observer);
        if(location.host === 'mam.clem.mobi' || location.host === `www.mam.clem.mobi` ) 
        {
          var mamsncf = `&brand=mamsncf`
        }else
        {
          var mamsncf = ``
        }


        this.http.get < any > (`https://api1.clem.mobi/api/v2/book_details_new/${bookId}?lang=${lang}&origin=website${mamsncf}` , header).subscribe(
          response => {
            observer.next( < BookResult > ( < BasicResponse > response).data);
            observer.complete();
          },
          error => {
            observer.next(null);
            observer.complete();

          }
        );
      });
    });
  }


  public postNewBook(stationId: number, userId: number, startDate: Date, endDate: Date, codepromo: string) {

    // todo  probleme de date   a revoir quand l api sera prete 
    let newStartDate =  new Date(startDate.getTime() - 3600 * 2000)
    let newEndDate =    new Date(endDate.getTime() - 3600 * 2000)

         if (codepromo === undefined){
           codepromo = ''
         }

         var date_start =  newStartDate.getFullYear() + "-" +
         ("0" + (newStartDate.getMonth()+1)).slice(-2) + "-" +
         ("0" + newStartDate.getDate()).slice(-2) + "T" +
         ("0" + newStartDate.getHours()).slice(-2) + ":" +
         ("0" + newStartDate.getMinutes()).slice(-2) + ":" +
         ("0" + newStartDate.getSeconds()).slice(-2)+"Z";

         var date_end =  newEndDate.getFullYear() + "-" +
         ("0" + (newEndDate.getMonth()+1)).slice(-2) + "-" +
         ("0" + newEndDate.getDate()).slice(-2) + "T" +
         ("0" + newEndDate.getHours()).slice(-2) + ":" +
         ("0" + newEndDate.getMinutes()).slice(-2) + ":" +
         ("0" + newEndDate.getSeconds()).slice(-2)+"Z";


         let tokenString = localStorage.getItem('token_clem_mobi')
         let token =  JSON.parse(tokenString)  
        
                let httpOptions = {
                  headers: new HttpHeaders()
                    .set('Authorization', 'Bearer ' +token.access_token)
                    .set('Content-Type', 'application/x-www-form-urlencoded')}
          return this.http.post<any>('https://api1.clem.mobi/api/v2/books',
          "driver_id=" + userId +
          "&stationid=" + stationId +
          "&startdate=" + date_start +
          "&enddate=" +  date_end +
          "&codepromo=" + codepromo +
          "&share=false",
        httpOptions);

        // this.http.post < any > ("https://api1.clem.mobi/api/v2/books",
        //   "driver_id=" + userId +
        //   "&stationid=" + stationId +
        //   "&startdate=" + date_start +
        //   "&enddate=" +  date_end +
        //   "&codepromo=" + codepromo +
        //   "&share=false", header).subscribe(
          // response => {
          //   observer.next( < BookResult > ( < BasicResponse > response).data);
          //   observer.complete();
          // },
          // error => {
          //   observer.next(null);
          //   observer.complete();

          // }
   
  
    

  }

  public postNewBookStat(station: any, user: any, startDate: Date, endDate: Date, ip_adress: any, url: any, connection: any) {

    // todo  probleme de date   a revoir quand l api sera prete 
    let newStartDate =  new Date(startDate.getTime() - 3600 * 2000)
    let newEndDate =    new Date(endDate.getTime() - 3600 * 2000)

         var date_start =  newStartDate.getFullYear() + "-" +
         ("0" + (newStartDate.getMonth()+1)).slice(-2) + "-" +
         ("0" + newStartDate.getDate()).slice(-2) + "T" +
         ("0" + newStartDate.getHours()).slice(-2) + ":" +
         ("0" + newStartDate.getMinutes()).slice(-2) + ":" +
         ("0" + newStartDate.getSeconds()).slice(-2)+"Z";

         var date_end =  newEndDate.getFullYear() + "-" +
         ("0" + (newEndDate.getMonth()+1)).slice(-2) + "-" +
         ("0" + newEndDate.getDate()).slice(-2) + "T" +
         ("0" + newEndDate.getHours()).slice(-2) + ":" +
         ("0" + newEndDate.getMinutes()).slice(-2) + ":" +
         ("0" + newEndDate.getSeconds()).slice(-2)+"Z";


         let tokenString = localStorage.getItem('token_clem_mobi')
         let token =  JSON.parse(tokenString)  
        
                let httpOptions = {
                  headers: new HttpHeaders()
                    .set('Authorization', 'Bearer ' +token.access_token)
                    .set('Content-Type', 'application/x-www-form-urlencoded')}
          return this.http.post<any>('https://api-oauth.clem.mobi/clemmobi/books',
          "driver_id=" + user.id +
          "&username=" + user.name +
          "&community_driver=" + user.community.name +
          "&station_id=" + station.id +
          "&station_name=" + station.name +
          "&startdate=" + date_start +
          "&enddate=" +  date_end +
          "&url=" + url +
          "&ip_adress=" + ip_adress.IPv4 +
          "&city=" + ip_adress.city +
          "&postal=" + ip_adress.postal +
          "&state=" + ip_adress.state + 
          "&country_name=" + ip_adress.country_name + 
          "&connection=" + connection,
        httpOptions);


  }








  public checkCodePromo(stationId: number, userId: number, startDate: Date, endDate: Date , codepromo: string, lang: string) {
    // conslog("post service");

    return new Observable < CodePromoResponse > ((observer) => {
      // conslog("post service");

      this.autorizationService.login(null).subscribe(reponse => {
        let token = < Token > reponse;
        // conslog("login");
        if (token == null) {
          observer.next(null)
          observer.complete()
        }

        var header = {
          headers: new HttpHeaders()
            .set('Authorization', 'Bearer ' + token.access_token)
            .set('Content-Type', 'application/x-www-form-urlencoded')
        }

        
        this.http.get < any > ("https://api1.clem.mobi/api/v2/books/checkpromo?"+
          "driver_id="+ userId +
          "&station_id=" + stationId +
          "&startdate=" + startDate.toISOString() +
          "&enddate=" + endDate.toISOString() +
          "&lang=" + lang +
          "&codepromo=" + codepromo
          , header).subscribe(
            response => {
              observer.next( < CodePromoResponse > ( < BasicResponse > response).data);
              observer.complete();
            },
            error => {
              observer.next(null);
              observer.complete();
  
            }
          );
      });
    });

  }

















  public getBookeBilanEcoResume(start: Date, end: Date) {
    return new Observable < BilanEco > ((observer) => {
      this.autorizationService.login(null).subscribe(response => {
        let token = < Token > response;
        let httpOptions = {
          headers: new HttpHeaders()
            .set('Authorization', 'Bearer ' + token.access_token)
        };
        this.userService.getCurrentUserData().subscribe(
          response => {
            let user : UserApi = response;
            this.http.get(this.publicUrl + "api/v2/users/" + user.id + "/bilan?startdate=" + start.toISOString() + "&enddate=" + end.toISOString(), httpOptions).subscribe(
              response => {
                let bilan = < BilanEco > ( < BasicResponse > response).data;
                observer.next(bilan);
                observer.complete();
              },
              error => {
                observer.next(undefined);
                observer.complete();
              }
            );
            
          },
          error => {
            // conserror(error);
            observer.error(null);
            observer.complete();
          }
        );
      }, error => {
        // conserror(error);
        observer.error(null);
        observer.complete();
      })
    })
  }

  public getBookeBilanEcoAllResume() {
    let end : Date = new Date();
    return new Observable < BilanEco > ((observer) => {
      this.autorizationService.login(null).subscribe(response => {
        let token = < Token > response;
        let httpOptions = {
          headers: new HttpHeaders()
            .set('Authorization', 'Bearer ' + token.access_token)
        };
        this.userService.getCurrentUserData().subscribe(
          response => {
            let user : UserApi = response;
            let start : Date = new Date('2017-01-01T00:00:01');

            this.http.get(this.publicUrl + "api/v2/users/" + user.id + "/bilan?startdate=" + start.toISOString() + "&enddate=" + end.toISOString(), httpOptions).subscribe(
              response => {
                let bilan = < BilanEco > ( < BasicResponse > response).data;
                observer.next(bilan);
                observer.complete();
              },
              error => {
                observer.next(undefined);
                observer.complete();
              }
            );
            
          },
          error => {
            // conserror(error);
            observer.error(null);
            observer.complete();
          }
        );
      }, error => {
        // conserror(error);
        observer.error(null);
        observer.complete();
      })
    })
  }

  public getBookBilanEco(book: BookResult, ) {
    return new Observable < BilanEco > ((observer) => {
      this.autorizationService.login(null).subscribe(response => {
          let token = < Token > response;
          let httpOptions = {
            headers: new HttpHeaders()
              .set('Authorization', 'Bearer ' + token.access_token)
          };

          let start = new Date(book.startdate);
          let end = new Date(book.enddate);

          this.http.get(this.publicUrl + "api/v2/users/" + book.driver_id + "/bilan?startdate=" + book.startdate + "&enddate=" + book.enddate, httpOptions).subscribe(
            response => {
              let bilan = < BilanEco > ( < BasicResponse > response).data;
              observer.next(bilan);
              observer.complete();
            },
            error => {
              observer.next(undefined);
              observer.complete();
            }
          );
        },
        error => {
          observer.next(undefined);
          observer.complete();
        },
      )
    });
  }


  public getStationBook() {
    // conslog("book service");
    return new Observable < Station > ((observer) => {
      // conslog("book service");

      this.autorizationService.login(null).subscribe(reponse => {
        let token = < Token > reponse;
        // conslog("login");
        if (token == null) {
          observer.next(null)
          observer.complete()
        }
        var header = {
          headers: new HttpHeaders()
            .set('Authorization', 'Bearer ' + token.access_token)
        }

        //            this.GetALLStations(0,token, observer);
        this.http.get(this.publicUrl + "/api/v2/books/availability?startdate=2018-09-23T16:00:00Z&enddate=2018-09-23T18:30:00Z&station_id=1615", header).subscribe(
          response => {
            observer.next(( < BasicResponse > response).data)
            observer.complete()
          }, error => {
            observer.next(( < BasicResponse > error).data)
            observer.complete()
          });

      });
    });

  }





  remoteStart(bookId): Observable<any> {

    let tokenString = localStorage.getItem('token_clem_mobi')
    let token =  JSON.parse(tokenString)  
   
           let httpOptions = {
             headers: new HttpHeaders()
               .set('Authorization', 'Bearer ' +token.access_token)}
               
     return this.http.put<any>(`${this.publicUrl}api/v2/books/${bookId}/unlock`, null, httpOptions);
   }



    remoteStop(bookId): Observable<any> {

    let tokenString = localStorage.getItem('token_clem_mobi')
    let token =  JSON.parse(tokenString)  
   
           let httpOptions = {
             headers: new HttpHeaders()
               .set('Authorization', 'Bearer ' +token.access_token)}
               
     return this.http.put<any>(`${this.publicUrl}api/v2/books/${bookId}/stop`, null, httpOptions);
   }



   actionRemote(element): Observable<any> {
     
     return this.http.get<any>(`${element}`);
   }









  constructor(private autorizationService: AutorizationService, private userService : UserApiService, private http: HttpClient, private cookieService: CookieService) {}
}
